// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__Znbqm"};